import classnames from 'classnames';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/user/selectors';
import { TenantButton } from 'components/Layout/SuperUserBar/TenantButton';
import { useCanSwitchTenancy } from 'hooks/useCurrentUser';
import { createTenancyBroadcastChannel, TenancyBroadcastMessageType } from './constants';
import { Tooltip } from '@bettercomp/ui-components';
import cn from './styles.module.scss';

type SuperUserBarProps = {
  className?: string;
};

export const SuperUserBar = ({ className }: SuperUserBarProps) => {
  const user = useSelector(selectUser);
  const { canSwitchTenancy } = useCanSwitchTenancy();
  const channel = useMemo(() => canSwitchTenancy ? createTenancyBroadcastChannel() : null, [canSwitchTenancy]);

  useEffect(() => {
    if (!channel) {
      return;
    }

    const tenancyChannelMessageHandler = (message: { data: TenancyBroadcastMessageType }) => {
      if (message.data === TenancyBroadcastMessageType.TenancySwitched) {
        window.location.reload();
      }
    };

    channel.addEventListener('message', tenancyChannelMessageHandler);

    return () => {
      channel.removeEventListener('message', tenancyChannelMessageHandler);
      channel.close();
    };
  }, [channel]);

  // Allow both Super Admins and Tenant Admins to see the bar
  if (!canSwitchTenancy) {
    return null;
  }

  return (
    <div className={classnames(className, cn.superUserBarWrapper)}>
      <div className={cn.superUserBar}>
        <div className={cn.companyName}>
          <Tooltip title={user?.Company?.name || ''}>
            <div className={cn.companyNameText}>
              {user?.Company?.name}
            </div>
          </Tooltip>
        </div>
        <TenantButton />
      </div>
    </div>
  )
};
